export default __webpack_public_path__ + "static/media/Babay-Adi.a0235bd0.png";